/* SimWellness cart drawer + pagination refinements — scoped and defensive */
(function () {
  'use strict';

  function installWellnessPaginationStyles() {
    if (document.getElementById('sw-borderless-pagination')) return;
    var style = document.createElement('style');
    style.id = 'sw-borderless-pagination';
    style.textContent = [
      'body.sw .pagination,body.sw .pagination-wrapper,body.sw .pagination__list{display:flex!important;align-items:center!important;justify-content:center!important;gap:22px!important;}',
      'body.sw .pagination li,body.sw .pagination__item,body.sw .pagination a,body.sw .pagination span,body.sw .pagination button,body.sw .pagination__list li,body.sw .pagination__list a,body.sw .pagination__list span{background:transparent!important;background-color:transparent!important;border:0!important;box-shadow:none!important;border-radius:0!important;width:auto!important;min-width:0!important;height:auto!important;min-height:0!important;padding:4px 0!important;color:#514B45!important;text-decoration:none!important;}',
      'body.sw .pagination .active,body.sw .pagination [aria-current="page"],body.sw .pagination__item--current,body.sw .pagination__list [aria-current="page"]{background:transparent!important;color:#24211E!important;font-weight:800!important;border:0!important;border-bottom:1px solid #24211E!important;}',
      'body.sw .pagination a:hover,body.sw .pagination button:hover,body.sw .pagination__list a:hover{background:transparent!important;color:#6F5142!important;border:0!important;text-decoration:none!important;}',
      'body.sw .pagination svg,body.sw .pagination__list svg{width:14px!important;height:14px!important;}',
      '@media(max-width:767px){body.sw .pagination,body.sw .pagination-wrapper,body.sw .pagination__list{gap:18px!important;}body.sw .pagination li,body.sw .pagination__item,body.sw .pagination a,body.sw .pagination span,body.sw .pagination button,body.sw .pagination__list li,body.sw .pagination__list a,body.sw .pagination__list span{font-size:14px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function refineWellnessCart() {
    if (!document.body || !document.body.classList.contains('sw')) return;
    installWellnessPaginationStyles();

    var forms = document.querySelectorAll('form[action*="/cart"]');
    forms.forEach(function (form) {
      var drawer = form.closest('aside');
      if (!drawer) return;

      var primary = drawer.querySelector('.sw-cart-drawer__primary');
      if (primary) {
        primary.textContent = 'Checkout';
        primary.setAttribute('href', '/checkout');
      }

      var paymentRow = form.previousElementSibling;
      if (!paymentRow || !paymentRow.querySelector('svg')) return;

      paymentRow.classList.add('sw-payment-icons-inline');
      paymentRow.style.setProperty('display', 'flex', 'important');
      paymentRow.style.setProperty('flex-wrap', 'nowrap', 'important');
      paymentRow.style.setProperty('justify-content', 'center', 'important');
      paymentRow.style.setProperty('align-items', 'center', 'important');
      paymentRow.style.setProperty('gap', '3px', 'important');
      paymentRow.style.setProperty('overflow', 'hidden', 'important');
      paymentRow.style.setProperty('padding-left', '12px', 'important');
      paymentRow.style.setProperty('padding-right', '12px', 'important');

      paymentRow.querySelectorAll('span').forEach(function (span) {
        span.style.setProperty('display', 'inline-flex', 'important');
        span.style.setProperty('flex', '0 1 auto', 'important');
        span.style.setProperty('min-width', '0', 'important');
      });

      paymentRow.querySelectorAll('svg').forEach(function (svg) {
        svg.style.setProperty('height', '15px', 'important');
        svg.style.setProperty('width', 'auto', 'important');
        svg.style.setProperty('max-width', '42px', 'important');
        svg.style.setProperty('display', 'block', 'important');
      });
    });
  }

  var scheduled = false;
  function scheduleRefine() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      refineWellnessCart();
    });
  }

  function boot() {
    refineWellnessCart();
    var observer = new MutationObserver(scheduleRefine);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}());


/* ---------- Sim Golfer PDP section reveal ---------- */
(function () {
  'use strict';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isSimGolferPdp() {
    if (!document.body || document.body.classList.contains('sw')) return false;

    var isProductTemplate = Array.prototype.some.call(
      document.body.classList,
      function (className) {
        return className === 'product' || className.indexOf('product-') === 0;
      }
    );

    return isProductTemplate;
  }

  function revealSections(scope) {
    if (!isSimGolferPdp() || reducedMotion()) return;

    var root = scope && scope.querySelectorAll ? scope : document;
    var sections = root.querySelectorAll('.sgpf:not([data-sg-reveal-ready]), .sgpf-stats:not([data-sg-reveal-ready]), .sg-tg:not([data-sg-reveal-ready]), .sg-tg-n1:not([data-sg-reveal-ready]), .sg-wittek-pdp:not([data-sg-reveal-ready])');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('sg-rv-in');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.07,
      rootMargin: '0px 0px -32px 0px'
    });

    sections.forEach(function (section) {
      section.setAttribute('data-sg-reveal-ready', '1');
      section.classList.add('sg-rv');
      observer.observe(section);
    });
  }

  function bootReveal() {
    revealSections(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootReveal, { once: true });
  } else {
    bootReveal();
  }

  document.addEventListener('shopify:section:load', function (event) {
    revealSections(event.target || document);
  });
}());

/* ---------- Sim Golfer at-a-glance stats ---------- */
(function () {
  'use strict';

  function isSimGolferPdp() {
    if (!document.body || document.body.classList.contains('sw')) return false;
    return Array.prototype.some.call(document.body.classList, function (className) {
      return className === 'product' || className.indexOf('product-') === 0;
    });
  }

  function reducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function text(el) {
    return String(el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function ensureHeading(grid) {
    if (!grid || grid.dataset.sgGlanceHeading === '1') return;
    grid.dataset.sgGlanceHeading = '1';

    if (
      !grid.classList.contains('sg-stats') &&
      !grid.classList.contains('sgpf-stats__grid') &&
      !grid.classList.contains('sg-wittek-stats')
    ) return;

    var host = grid.parentElement;
    if (!host) return;

    var existing = host.querySelector('.sg-glance-heading');
    if (existing) return;

    var heading = document.createElement('div');
    heading.className = 'sg-glance-heading';
    heading.innerHTML =
      '<span class="sg-glance-heading__line" aria-hidden="true"></span>';
    host.insertBefore(heading, grid);
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', 'Product highlights');
  }

  function sizeValue(el) {
    if (!el) return;
    var length = text(el).length;
    el.classList.add('sg-stat-value');
    el.classList.remove('sg-stat-value--long', 'sg-stat-value--xlong');
    if (length > 14) el.classList.add('sg-stat-value--xlong');
    else if (length > 8) el.classList.add('sg-stat-value--long');
  }

  function decorateCards(grid, selector, valueSelector, labelSelector) {
    grid.classList.add('sg-at-a-glance');
    ensureHeading(grid);

    var cards = selector ? grid.querySelectorAll(selector) : grid.children;
    Array.prototype.forEach.call(cards, function (card) {
      if (!card || card.nodeType !== 1) return;
      card.classList.add('sg-stat-card');

      var value = valueSelector ? card.querySelector(valueSelector) : card.children[0];
      var label = labelSelector ? card.querySelector(labelSelector) : card.children[card.children.length - 1];

      sizeValue(value);
      if (label && label !== value) label.classList.add('sg-stat-label');
    });
  }

  function decorate(scope) {
    if (!isSimGolferPdp()) return;
    var root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll('.sg-stats').forEach(function (grid) {
      decorateCards(grid);
    });

    root.querySelectorAll('.sgpf-stats__grid').forEach(function (grid) {
      decorateCards(grid, '.sgpf-stat', '.sgpf-stat__value', '.sgpf-stat__label');
    });

    root.querySelectorAll('.sg-tg-n1__stats').forEach(function (grid) {
      decorateCards(grid, '.sg-tg-n1__stat');
      grid.classList.add('sg-at-a-glance--trugolf');
    });

    root.querySelectorAll('.sg-tg__stats').forEach(function (grid) {
      decorateCards(grid, '.sg-tg__stat');
      grid.classList.add('sg-at-a-glance--trugolf');
    });

    root.querySelectorAll('.sg-wittek-stats').forEach(function (grid) {
      decorateCards(grid, null, 'dd', 'dt');
      grid.classList.add('sg-at-a-glance--wittek');
    });
  }

  function labelFor(el) {
    var card = el.closest('.sg-stat-card') || el.parentElement;
    if (!card) return '';
    var label = card.querySelector && card.querySelector('.sg-stat-label');
    return text(label || card).toLowerCase();
  }

  function shouldCount(el, original) {
    var raw = String(original || '').toLowerCase();
    var label = labelFor(el);

    var blockedLabels = [
      'height','width','length','depth','dimension','mount height',
      'from screen','enclosure depth','retractable screen','pixel pitch',
      'pipe frame','base thickness','resolution','voltage','volt',
      'horsepower','lead time','room','footprint','throw ratio',
      'aspect ratio','diagonal','hitting zone','price','cost',
      'warranty','weight','pounds','load capacity','cart weight',
      'hitting strip weight','inch display','battery life','battery'
    ];

    for (var i = 0; i < blockedLabels.length; i++) {
      if (label.indexOf(blockedLabels[i]) > -1) return false;
    }

    if (raw.indexOf('×') > -1 || raw.indexOf(' x ') > -1 || /\d\s*[–—-]\s*\d/.test(raw)) return false;
    if (/[$£€]/.test(raw)) return false;
    if (/\b\d+(?:\.\d+)?\s*(?:ft|feet|foot|in|inch|inches|mm|cm|m|lbs?|pounds?|kg|mph|hr|hrs|hour|hours|yr|yrs|year|years|week|weeks)\b/.test(raw)) return false;
    if (/\d\s*(?:″|")/.test(raw)) return false;

    return true;
  }

  function parseCounter(el) {
    var original = text(el);
    var explicit = el.getAttribute('data-count');

    if (explicit !== null && explicit !== '') {
      var raw = String(explicit).replace(/,/g, '');
      var target = parseFloat(raw);
      if (!isFinite(target)) return null;

      return {
        original: original,
        target: target,
        prefix: el.getAttribute('data-prefix') || '',
        suffix: el.getAttribute('data-sfx') || '',
        decimals: (raw.split('.')[1] || '').length
      };
    }

    var groups = original.match(/[0-9][0-9,]*(?:\.[0-9]+)?/g);
    if (!groups || groups.length !== 1) return null;

    var match = original.match(/^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/);
    if (!match) return null;

    var rawNumber = match[2].replace(/,/g, '');
    var inferred = parseFloat(rawNumber);
    if (!isFinite(inferred)) return null;

    return {
      original: original,
      target: inferred,
      prefix: match[1] || '',
      suffix: match[3] || '',
      decimals: (rawNumber.split('.')[1] || '').length
    };
  }

  function formatNumber(value, decimals) {
    if (decimals > 0) {
      return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    }
    return Math.floor(value).toLocaleString();
  }

  function animate(el, data) {
    if (el.dataset.sgCounted === '1') return;
    el.dataset.sgCounted = '1';

    if (reducedMotion()) {
      el.textContent = data.original;
      return;
    }

    var started = null;
    var duration = 1100;

    function tick(ts) {
      if (started === null) started = ts;
      var progress = Math.min((ts - started) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 4);
      el.textContent = data.prefix + formatNumber(data.target * eased, data.decimals) + data.suffix;

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      } else {
        el.textContent = data.original;
      }
    }

    window.requestAnimationFrame(tick);
  }

  function candidates(root) {
    return root.querySelectorAll([
      '.sg-stats [data-count]',
      '.sgpf-stats [data-count]',
      '.sg-tg-n1__stats .sg-tg-n1__stat',
      '.sg-tg__stats .sg-tg__stat',
      '.sg-wittek-stats dd'
    ].join(','));
  }

  function setupCounters(scope) {
    if (!isSimGolferPdp()) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = candidates(root);
    if (!nodes.length) return;

    var eligible = [];
    nodes.forEach(function (el) {
      if (el.dataset.sgCounterReady === '1') return;
      el.dataset.sgCounterReady = '1';

      var data = parseCounter(el);
      if (!data || !shouldCount(el, data.original)) return;

      el.__sgCounterData = data;
      eligible.push(el);
    });

    if (!eligible.length) return;

    if (!('IntersectionObserver' in window)) {
      eligible.forEach(function (el) { animate(el, el.__sgCounterData); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animate(entry.target, entry.target.__sgCounterData);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.6 });

    eligible.forEach(function (el) { observer.observe(el); });
  }

  function boot(scope) {
    decorate(scope || document);
    setupCounters(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
}());


/* ---------- Sim Golfer buyer guide editorial treatment ---------- */
(function () {
  'use strict';

  function isSimGolferPdp() {
    if (!document.body || document.body.classList.contains('sw')) return false;
    return Array.prototype.some.call(document.body.classList, function (className) {
      return className === 'product' || className.indexOf('product-') === 0;
    });
  }

  function text(el) {
    return String(el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isBuyerGuide(section) {
    var heading = section.querySelector('h2');
    if (!heading || text(heading).toLowerCase().indexOf('is this right for you') === -1) return false;

    var spans = section.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      if (text(spans[i]).toLowerCase() === "buyer's guide") {
        spans[i].classList.add('sg-buyer-eyebrow');
        return true;
      }
    }
    return false;
  }

  function markRule(section) {
    var divs = section.querySelectorAll('div');
    for (var i = 0; i < divs.length; i++) {
      var style = String(divs[i].getAttribute('style') || '').toLowerCase().replace(/\s+/g, '');
      if (
        style.indexOf('width:36px') > -1 &&
        style.indexOf('height:2px') > -1 &&
        style.indexOf('#c5a55a') > -1
      ) {
        divs[i].classList.add('sg-buyer-rule');
        return;
      }
    }
  }

  function cardStatus(card) {
    var style = String(card.getAttribute('style') || '').toLowerCase();
    var classes = String(card.className || '').toLowerCase();
    var copy = text(card).toLowerCase();

    if (
      style.indexOf('#fca5a5') > -1 ||
      style.indexOf('#d97706') > -1 ||
      /(^|\s)red(\s|$)/.test(classes) ||
      copy.indexOf('worth knowing') > -1
    ) return 'caution';

    return 'positive';
  }

  function looksLikeCard(el) {
    if (!el || el.nodeType !== 1 || el.tagName !== 'DIV') return false;

    var classes = String(el.className || '').toLowerCase();
    if (classes.indexOf('bmt-fit-card') > -1 || classes.indexOf('eyexr-fit-card') > -1) return true;

    var style = String(el.getAttribute('style') || '').toLowerCase().replace(/\s+/g, '');
    var coloredBorder =
      style.indexOf('#86efac') > -1 ||
      style.indexOf('#fca5a5') > -1 ||
      style.indexOf('border-top:3pxsolid#16a34a') > -1 ||
      style.indexOf('border-top:3pxsolid#d97706') > -1;

    return coloredBorder;
  }

  function decorateCard(card) {
    if (card.dataset.sgBuyerReady === '1') return;
    card.dataset.sgBuyerReady = '1';
    card.classList.add('sg-buyer-card');

    var status = cardStatus(card);
    card.classList.add(status === 'caution' ? 'sg-buyer-card--caution' : 'sg-buyer-card--positive');

    if (card.parentElement) card.parentElement.classList.add('sg-buyer-list');

    var spans = card.querySelectorAll('span');
    spans.forEach(function (span) {
      var copy = text(span).toLowerCase();
      if (copy.indexOf('great fit') === 0 || copy.indexOf('worth knowing') === 0) {
        span.classList.add('sg-buyer-badge');
      }
    });
  }

  function buyerSectionForHeading(h2) {
    var sg = h2.closest && h2.closest('.sgpf');
    if (sg) return sg;

    var node = h2.parentElement;
    for (var i = 0; node && node !== document.body && i < 5; i++, node = node.parentElement) {
      var style = String(node.getAttribute && node.getAttribute('style') || '').toLowerCase().replace(/\s+/g, '');
      if (style.indexOf('background:') > -1 && style.indexOf('padding:') > -1) return node;
    }

    return h2.parentElement && h2.parentElement.parentElement;
  }

  function decorateBuyerGuides(scope) {
    if (!isSimGolferPdp()) return;
    var root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll('h2').forEach(function (heading) {
      if (text(heading).toLowerCase().indexOf('is this right for you') === -1) return;

      var section = buyerSectionForHeading(heading);
      if (!section || !isBuyerGuide(section)) return;
      if (section.dataset.sgBuyerSectionReady === '1') return;

      section.dataset.sgBuyerSectionReady = '1';
      section.classList.add('sg-buyers-guide');
      markRule(section);

      section.querySelectorAll('div').forEach(function (el) {
        if (looksLikeCard(el)) decorateCard(el);
      });
    });
  }

  function boot(scope) {
    decorateBuyerGuides(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
}());

/* ---------- Sim Golfer compatibility + build editorial treatment ---------- */
(function () {
  'use strict';

  function isSimGolferPdp() {
    if (!document.body || document.body.classList.contains('sw')) return false;
    return Array.prototype.some.call(document.body.classList, function (className) {
      return className === 'product' || className.indexOf('product-') === 0;
    });
  }

  function txt(el) {
    return String(el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function styleText(el) {
    return String(el && el.getAttribute && el.getAttribute('style') || '').toLowerCase().replace(/\s+/g, '');
  }

  function sectionFor(h2) {
    var sg = h2.closest && h2.closest('.sgpf');
    if (sg) return sg;
    var node = h2.parentElement;
    for (var i = 0; node && node !== document.body && i < 4; i++, node = node.parentElement) {
      var st = styleText(node);
      if (st.indexOf('background:') > -1 && st.indexOf('padding:') > -1) return node;
    }
    return h2.parentElement && h2.parentElement.parentElement;
  }

  function markEyebrowAndRule(section) {
    var spans = section.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var st = styleText(spans[i]);
      if (st.indexOf('text-transform:uppercase') > -1 && st.indexOf('letter-spacing:3px') > -1) {
        spans[i].classList.add('sg-editorial-eyebrow');
        break;
      }
    }

    var divs = section.querySelectorAll('div');
    for (var j = 0; j < divs.length; j++) {
      var ds = styleText(divs[j]);
      if (ds.indexOf('width:36px') > -1 && ds.indexOf('height:2px') > -1 && ds.indexOf('#c5a55a') > -1) {
        divs[j].classList.add('sg-editorial-rule');
        break;
      }
    }
  }

  function isNote(el) {
    var st = styleText(el);
    return st.indexOf('border-left:3px') > -1 || st.indexOf('border-left:2px') > -1;
  }

  function isRoundedCard(el) {
    if (!el || !el.getAttribute) return false;
    var st = styleText(el);
    var rounded = /border-radius:(?:8px|10px|12px|20px)/.test(st);
    var shadow = st.indexOf('box-shadow:') > -1 && st.indexOf('box-shadow:none') === -1;
    var whiteish = st.indexOf('background:#fff') > -1 || st.indexOf('background:rgba(255,255,255') > -1;
    return rounded && (whiteish || shadow || st.indexOf('border:1px') > -1);
  }

  function topLevelCandidates(section, selector, predicate) {
    var all = Array.prototype.filter.call(section.querySelectorAll(selector), predicate);
    return all.filter(function (el) {
      return !all.some(function (other) {
        return other !== el && other.contains(el);
      });
    });
  }

  function markRowParts(row, prefix) {
    var direct = Array.prototype.filter.call(row.children || [], function (el) {
      return el && el.nodeType === 1;
    });

    var name = null;
    var desc = null;
    var meta = null;

    direct.forEach(function (el) {
      var t = txt(el).toLowerCase();

      if (!t && el.querySelector && el.querySelector('svg')) {
        el.classList.add(prefix + '-icon');
        return;
      }

      if (!meta && (
        t.indexOf('view') === 0 ||
        t.indexOf('sourced separately') > -1 ||
        t.indexOf('included') === 0 ||
        t.indexOf('request a quote') === 0 ||
        t.indexOf('shop ') === 0
      )) {
        meta = el;
        return;
      }

      if (!name && t && (el.tagName === 'H3' || el.tagName === 'H4' || el.tagName === 'DIV' || el.tagName === 'SPAN')) {
        name = el;
        return;
      }

      if (!desc && t && (el.tagName === 'P' || el.tagName === 'DIV' || el.tagName === 'SPAN')) {
        desc = el;
      }
    });

    if (name) name.classList.add(prefix + '-name');
    if (desc && desc !== name && desc !== meta) desc.classList.add(prefix + '-desc');
    if (meta) meta.classList.add(prefix + '-meta');
  }

  function decorateCompatibility(section) {
    if (section.dataset.sgCompatEditorial === '1') return;
    if (section.classList.contains('sg-system-compat')) return;

    var chips = Array.prototype.filter.call(section.querySelectorAll('span'), function (span) {
      var st = styleText(span);
      return st.indexOf('border-radius:20px') > -1 || st.indexOf('#bbf7d0') > -1 || st.indexOf('#f0fdf4') > -1;
    });

    var cards = topLevelCandidates(section, 'div', function (el) {
      return !isNote(el) && isRoundedCard(el) && txt(el).length > 0;
    });

    if (!chips.length && !cards.length) return;

    section.dataset.sgCompatEditorial = '1';
    section.classList.add('sg-compat-editorial');
    markEyebrowAndRule(section);

    var headings = section.querySelectorAll('h2');
    if (headings.length > 1) {
      var firstHeading = txt(headings[0]).toLowerCase();
      for (var h = 1; h < headings.length; h++) {
        if (txt(headings[h]).toLowerCase() === firstHeading) {
          headings[h].classList.add('sg-compat-duplicate-heading');
        }
      }
    }

    chips.forEach(function (chip) {
      chip.classList.add('sg-compat-chip');
      if (chip.parentElement) chip.parentElement.classList.add('sg-compat-chip-list');
    });

    cards.forEach(function (card) {
      card.classList.add('sg-compat-card');
      if (card.parentElement) card.parentElement.classList.add('sg-compat-list');

      var direct = Array.prototype.filter.call(card.children || [], function (el) {
        return el && el.nodeType === 1;
      });
      if (direct[0]) direct[0].classList.add('sg-compat-name');
      for (var i = 1; i < direct.length; i++) {
        if (direct[i].tagName === 'P' || direct[i].tagName === 'DIV') {
          direct[i].classList.add('sg-compat-desc');
          break;
        }
      }
    });

    section.querySelectorAll('div').forEach(function (el) {
      if (isNote(el)) el.classList.add('sg-editorial-note');
    });
  }

  function decorateBuild(section) {
    if (section && section.closest && section.closest('.sg-wittek-pdp')) return;
    if (section.classList.contains('sg-zk-build')) return;

    section.classList.add('sg-build-editorial');
    markEyebrowAndRule(section);

    var cards = topLevelCandidates(section, 'a,div,article', function (el) {
      return !isNote(el) && isRoundedCard(el) && txt(el).length > 0;
    });

    function addCard(child) {
      if (
        !child ||
        child.nodeType !== 1 ||
        (child.tagName !== 'A' && child.tagName !== 'DIV' && child.tagName !== 'ARTICLE') ||
        isNote(child) ||
        txt(child).length === 0 ||
        cards.indexOf(child) !== -1
      ) return;

      var childStyle = styleText(child);
      var knownRow = child.classList.contains('bmt-feature-card') ||
        child.classList.contains('sg-build-row') ||
        child.classList.contains('sg-also-card') ||
        child.tagName === 'A';
      var visuallyCard = isRoundedCard(child) ||
        childStyle.indexOf('border-bottom:') > -1;

      if (!knownRow && !visuallyCard) return;
      cards.push(child);
    }

    ['.sg-also', '.bmt-features', '.eyexr-features'].forEach(function (selector) {
      section.querySelectorAll(selector).forEach(function (list) {
        Array.prototype.forEach.call(list.children || [], addCard);
      });
    });

    section.querySelectorAll('div').forEach(function (list) {
      var st = styleText(list);
      var likelyList =
        st.indexOf('flex-wrap:wrap') > -1 ||
        st.indexOf('display:grid') > -1;

      if (!likelyList) return;
      Array.prototype.forEach.call(list.children || [], addCard);
    });

    cards.forEach(function (card) {
      var direct = Array.prototype.filter.call(card.children || [], function (el) {
        return el && el.nodeType === 1;
      });

      var quoteAction = null;
      var genericView = null;

      direct.forEach(function (el) {
        var t = txt(el).toLowerCase();
        if (t.indexOf('request a quote') === 0) quoteAction = el;
        if (t === 'view →' || t === 'view' || t.indexOf('view →') === 0) genericView = el;
      });

      if (quoteAction && genericView && quoteAction !== genericView) {
        genericView.remove();
      }

      card.classList.add('sg-build-row');
      if (card.parentElement) card.parentElement.classList.add('sg-build-list');
      markRowParts(card, 'sg-build');
    });

    var listRowCount = 0;
    section.querySelectorAll('ul').forEach(function (list) {
      var rows = Array.prototype.filter.call(list.children || [], function (child) {
        return child && child.nodeType === 1 && child.tagName === 'LI' && txt(child).length > 0;
      });
      if (!rows.length) return;
      list.classList.add('sg-build-list', 'sg-build-bullet-list');
      rows.forEach(function (row) {
        row.classList.add('sg-build-row', 'sg-build-bullet-row');
        markRowParts(row, 'sg-build');
        listRowCount++;
      });
    });

    var tableCount = 0;
    section.querySelectorAll('table').forEach(function (table) {
      table.classList.add('sg-build-table');
      tableCount++;
    });

    section.querySelectorAll('div').forEach(function (el) {
      if (isNote(el)) el.classList.add('sg-editorial-note');
    });

    if (cards.length || listRowCount || tableCount) {
      section.dataset.sgBuildEditorial = '1';
    }
  }

  function boot(scope) {
    if (!isSimGolferPdp()) return;
    var root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll('h2').forEach(function (h2) {
      var heading = txt(h2).toLowerCase().replace(/[’‘]/g, "'").replace(/'+/g, "'");
      var section = sectionFor(h2);
      if (!section) return;

      if (heading === "what's included" || heading === "what's in the box" || heading === 'in the box') {
        section.classList.add('sg-included-editorial');
        section.classList.remove('sg-build-editorial');
        delete section.dataset.sgBuildEditorial;
        section.querySelectorAll('.sg-build-list,.sg-build-row,.sg-build-bullet-list,.sg-build-bullet-row,.sg-build-name,.sg-build-desc,.sg-build-meta,.sg-build-icon').forEach(function (el) {
          el.classList.remove('sg-build-list','sg-build-row','sg-build-bullet-list','sg-build-bullet-row','sg-build-name','sg-build-desc','sg-build-meta','sg-build-icon');
          if (el.dataset) delete el.dataset.sgBuildRowV6;
        });
        return;
      }

      if (
        heading === 'compatible software' ||
        heading === 'compatible simulator software' ||
        heading === 'compatible devices & software' ||
        heading === 'compatible with' ||
        heading === 'compatible software & launch monitors' ||
        heading === 'compatible hardware' ||
        heading === 'software & compatibility'
      ) {
        decorateCompatibility(section);
      }

      var buildEyebrow = Array.prototype.some.call(section.querySelectorAll('span'), function (span) {
        var label = txt(span).toLowerCase().replace(/[’‘]/g, "'").replace(/'+/g, "'");
        return (
          label === 'build your setup' ||
          label === 'complete your setup' ||
          label === 'complete the setup'
        );
      });

      if (
        heading === "what you'll also need" ||
        heading === 'build your setup' ||
        heading === 'popular add-ons' ||
        heading === 'add the pieces that suit your room' ||
        heading === 'choose a compatible mat' ||
        buildEyebrow
      ) {
        decorateBuild(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });

  /* sg-build-editorial-refresh-v2
     Some product custom-liquid blocks finish rendering after DOMContentLoaded.
     Re-run the decorator after child-list changes so late cards become rows too. */
  var sgEditorialRefreshTimer = null;
  var sgEditorialRoot = document.querySelector('main') || document.body;
  if (sgEditorialRoot && 'MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      var hasAddedContent = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length;
      });
      if (!hasAddedContent) return;
      window.clearTimeout(sgEditorialRefreshTimer);
      sgEditorialRefreshTimer = window.setTimeout(function () {
        boot(document);
      }, 80);
    }).observe(sgEditorialRoot, { childList: true, subtree: true });
  }

  window.addEventListener('load', function () {
    boot(document);
  }, { once: true });
}());



/* sg-build-runtime-hardening-v6 */
(function () {
  'use strict';

  function text(el) {
    return String(el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function styleText(el) {
    return String(el && el.getAttribute && el.getAttribute('style') || '').toLowerCase().replace(/\s+/g, '');
  }

  function isSimGolferProduct() {
    if (!document.body || document.body.classList.contains('sw')) return false;
    if (/^\/products\//.test(window.location.pathname || '')) return true;
    return Array.prototype.some.call(document.body.classList, function (name) {
      return name === 'product' || name.indexOf('product-') === 0;
    });
  }

  function findSection(h2) {
    var sgpf = h2.closest && h2.closest('.sgpf');
    if (sgpf) return sgpf;

    var node = h2.parentElement;
    for (var i = 0; node && node !== document.body && i < 5; i++, node = node.parentElement) {
      var st = styleText(node);
      if (st.indexOf('background:') > -1 && st.indexOf('padding:') > -1) return node;
    }
    return h2.parentElement && h2.parentElement.parentElement;
  }

  function addHeadingClasses(section) {
    var spans = section.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var s = styleText(spans[i]);
      if (s.indexOf('text-transform:uppercase') > -1 && s.indexOf('letter-spacing:3px') > -1) {
        spans[i].classList.add('sg-editorial-eyebrow');
        break;
      }
    }

    var divs = section.querySelectorAll('div');
    for (var j = 0; j < divs.length; j++) {
      var d = styleText(divs[j]);
      if (d.indexOf('width:36px') > -1 && d.indexOf('height:2px') > -1 && d.indexOf('#c5a55a') > -1) {
        divs[j].classList.add('sg-editorial-rule');
        break;
      }
    }
  }

  function looksCard(el) {
    var s = styleText(el);
    var rounded = /border-radius:(?:6px|8px|10px|12px|14px|16px|20px)/.test(s);
    var bordered = s.indexOf('border:1px') > -1 || s.indexOf('border-bottom:') > -1;
    var shadow = s.indexOf('box-shadow:') > -1 && s.indexOf('box-shadow:none') === -1;
    var whiteish = s.indexOf('background:#fff') > -1 || s.indexOf('background:rgba(255,255,255') > -1;
    var known = el.classList.contains('bmt-feature-card');
    var linkedAction = el.tagName === 'A' && /(?:view|request a quote|shop)/i.test(text(el));
    return known || linkedAction || (rounded && (bordered || shadow || whiteish));
  }

  function classifyRow(row) {
    if (!row || row.dataset.sgBuildRowV6 === '1') return;
    row.dataset.sgBuildRowV6 = '1';
    row.classList.add('sg-build-row');

    var direct = Array.prototype.filter.call(row.children || [], function (el) {
      return el && el.nodeType === 1;
    });

    var name = null;
    var desc = null;
    var meta = null;

    direct.forEach(function (el) {
      var t = text(el).toLowerCase();

      if (!t && el.querySelector && el.querySelector('svg')) {
        el.classList.add('sg-build-icon');
        return;
      }

      if (!t && styleText(el).indexOf('width:6px') > -1) {
        el.classList.add('sg-build-icon');
        return;
      }

      if (!meta && (
        t.indexOf('request a quote') === 0 ||
        t.indexOf('view') === 0 ||
        t.indexOf('sourced separately') > -1 ||
        t.indexOf('included') === 0 ||
        t.indexOf('shop ') === 0
      )) {
        meta = el;
        return;
      }

      if (!name && t && (
        el.tagName === 'H3' ||
        el.tagName === 'H4' ||
        el.tagName === 'STRONG' ||
        el.tagName === 'DIV' ||
        el.tagName === 'SPAN'
      )) {
        name = el;
        return;
      }

      if (!desc && t && (
        el.tagName === 'P' ||
        el.tagName === 'DIV' ||
        el.tagName === 'SPAN'
      )) {
        desc = el;
      }
    });

    if (name) name.classList.add('sg-build-name');
    if (desc && desc !== name && desc !== meta) desc.classList.add('sg-build-desc');
    if (meta) meta.classList.add('sg-build-meta');

    var quote = null;
    var view = null;
    direct.forEach(function (el) {
      var t = text(el).toLowerCase();
      if (t.indexOf('request a quote') === 0) quote = el;
      if (t === 'view →' || t === 'view') view = el;
    });
    if (quote && view && quote !== view) view.remove();
  }

  function decorate(section) {
    if (!section) return;
    if (section.closest && section.closest('.sg-wittek-pdp')) return;
    section.classList.add('sg-build-editorial');
    section.dataset.sgBuildEditorial = '1';
    addHeadingClasses(section);

    var candidates = Array.prototype.filter.call(section.querySelectorAll('a,div'), function (el) {
      return text(el).length > 0 && looksCard(el);
    });

    candidates = candidates.filter(function (el) {
      return !candidates.some(function (other) {
        return other !== el && other.contains(el);
      });
    });

    ['.sg-also', '.bmt-features', '.eyexr-features'].forEach(function (selector) {
      section.querySelectorAll(selector).forEach(function (list) {
        Array.prototype.forEach.call(list.children || [], function (child) {
          if (child && child.nodeType === 1 && text(child).length > 0 && candidates.indexOf(child) === -1) {
            candidates.push(child);
          }
        });
      });
    });

    if (!candidates.length) {
      var list = section.querySelector('ul');
      if (list) {
        Array.prototype.forEach.call(list.children || [], function (li) {
          if (li && li.tagName === 'LI' && text(li).length > 0) candidates.push(li);
        });
      }
    }

    candidates.forEach(function (row) {
      if (row.parentElement) row.parentElement.classList.add('sg-build-list');
      classifyRow(row);
    });

    section.querySelectorAll('div').forEach(function (el) {
      var s = styleText(el);
      if (s.indexOf('border-left:3px') > -1 || s.indexOf('border-left:2px') > -1) {
        el.classList.add('sg-editorial-note');
      }
    });
  }

  function run(root) {
    if (!isSimGolferProduct()) return;
    (root || document).querySelectorAll('h2').forEach(function (h2) {
      var heading = text(h2).toLowerCase().replace(/[’‘]/g, "'");
      if (
        heading === "what you'll also need" ||
        heading === 'build your setup' ||
        heading === 'popular add-ons' ||
        heading === 'add the pieces that suit your room'
      ) {
        decorate(findSection(h2));
      }
    });
  }

  var queued = false;
  function queueRun() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      run(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); }, { once: true });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target || document);
  });

  new MutationObserver(queueRun).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}());


/* sg-build-runtime-normalizer-v7 */
(function () {
  'use strict';

  function isSimGolferProduct() {
    if (!document.body || document.body.classList.contains('sw')) return false;
    return Array.prototype.some.call(document.body.classList, function (c) {
      return c === 'product' || c.indexOf('product-') === 0;
    });
  }

  function text(el) {
    return String(el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function buildHeading(h2) {
    var t = text(h2).toLowerCase().replace(/[’‘]/g, "'").replace(/'+/g, "'");
    return (
      t === "what you'll also need" ||
      t === 'build your setup' ||
      t === 'popular add-ons' ||
      t === 'add the pieces that suit your room' ||
      t === 'choose a compatible mat'
    );
  }

  function findSection(h2) {
    var sg = h2.closest && h2.closest('.sgpf, .sg-build-editorial');
    if (sg) return sg;
    var node = h2.parentElement;
    for (var i = 0; node && node !== document.body && i < 5; i++, node = node.parentElement) {
      var s = String(node.getAttribute && node.getAttribute('style') || '').toLowerCase().replace(/\s+/g, '');
      if (s.indexOf('background:') > -1 && s.indexOf('padding:') > -1) return node;
    }
    return h2.parentElement && h2.parentElement.parentElement;
  }

  function forceColor(root, color) {
    if (!root) return;
    root.style.setProperty('color', color, 'important');
    root.querySelectorAll('*').forEach(function (el) {
      if (el.tagName !== 'SVG' && el.tagName !== 'PATH') {
        el.style.setProperty('color', color, 'important');
      }
    });
  }

  function normalizeSection(section) {
    if (!section) return;
    if (section.closest && section.closest('.sg-wittek-pdp')) return;
    section.classList.add('sg-build-editorial');
    section.style.setProperty('background', '#002E22', 'important');
    section.style.setProperty('background-color', '#002E22', 'important');
    section.style.setProperty('color', '#ffffff', 'important');
    section.style.setProperty('overflow-x', 'hidden', 'important');
    section.style.setProperty('max-width', '100%', 'important');
    section.style.setProperty('box-sizing', 'border-box', 'important');

    var heading = section.querySelector('h2');
    if (heading) heading.style.setProperty('color', '#ffffff', 'important');

    section.querySelectorAll('.sg-editorial-eyebrow').forEach(function (el) {
      forceColor(el, 'rgba(255,255,255,.78)');
    });

    section.querySelectorAll('.sg-build-list').forEach(function (list) {
      list.style.setProperty('display', 'block', 'important');
      list.style.setProperty('width', '100%', 'important');
      list.style.setProperty('max-width', '100%', 'important');
      list.style.setProperty('min-width', '0', 'important');
      list.style.setProperty('margin-left', '0', 'important');
      list.style.setProperty('margin-right', '0', 'important');
      list.style.setProperty('transform', 'none', 'important');
      list.style.setProperty('box-sizing', 'border-box', 'important');

      var parent = list.parentElement;
      while (parent && parent !== section) {
        parent.style.setProperty('min-width', '0', 'important');
        parent.style.setProperty('max-width', '100%', 'important');
        parent.style.setProperty('width', '100%', 'important');
        parent.style.setProperty('box-sizing', 'border-box', 'important');
        parent.style.setProperty('transform', 'none', 'important');
        if (parent.style && parent.style.flex) {
          parent.style.setProperty('flex', '0 1 auto', 'important');
        }
        parent = parent.parentElement;
      }
    });

    section.querySelectorAll('.sg-build-row').forEach(function (row) {
      row.style.setProperty('width', '100%', 'important');
      row.style.setProperty('max-width', '100%', 'important');
      row.style.setProperty('min-width', '0', 'important');
      row.style.setProperty('height', 'auto', 'important');
      row.style.setProperty('min-height', '0', 'important');
      row.style.setProperty('margin-left', '0', 'important');
      row.style.setProperty('margin-right', '0', 'important');
      row.style.setProperty('background', 'transparent', 'important');
      row.style.setProperty('background-color', 'transparent', 'important');
      row.style.setProperty('border-radius', '0', 'important');
      row.style.setProperty('box-shadow', 'none', 'important');
      row.style.setProperty('box-sizing', 'border-box', 'important');
      row.style.setProperty('transform', 'none', 'important');

      var name = row.querySelector('.sg-build-name');
      var desc = row.querySelector('.sg-build-desc');
      var meta = row.querySelector('.sg-build-meta');

      if (name) forceColor(name, '#ffffff');
      if (desc) forceColor(desc, 'rgba(255,255,255,.68)');
      if (meta) forceColor(meta, '#D7BD78');

      var quote = null;
      var view = null;
      Array.prototype.forEach.call(row.children || [], function (el) {
        var t = text(el).toLowerCase();
        if (t.indexOf('request a quote') === 0) quote = el;
        if (t === 'view →' || t === 'view') view = el;
      });
      if (quote && view && quote !== view) view.remove();
    });

    section.querySelectorAll('ul.sg-build-list > li').forEach(function (li) {
      li.style.setProperty('min-width', '0', 'important');
      li.style.setProperty('max-width', '100%', 'important');
      li.style.setProperty('width', '100%', 'important');
      li.style.setProperty('box-sizing', 'border-box', 'important');
    });

    section.querySelectorAll('.sg-editorial-note').forEach(function (note) {
      forceColor(note, 'rgba(255,255,255,.70)');
    });
  }

  function run() {
    if (!isSimGolferProduct()) return;
    document.querySelectorAll('h2').forEach(function (h2) {
      if (buildHeading(h2)) normalizeSection(findSection(h2));
    });
  }

  var timer = null;
  function queue() {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, 30);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', queue);
  window.addEventListener('resize', queue, { passive: true });

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return m.addedNodes && m.addedNodes.length;
      });
      if (relevant) queue();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}());


/* sg-build-heading-normalize-v8 */
(function () {
  'use strict';
  function normalizeHeadingText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/[’‘]/g, "'")
      .replace(/'{2,}/g, "'");
  }

  function findSection(h2) {
    var sg = h2.closest && h2.closest('.sgpf, .sg-build-editorial');
    if (sg) return sg;
    var node = h2.parentElement;
    for (var i = 0; node && node !== document.body && i < 5; i++, node = node.parentElement) {
      var s = String(node.getAttribute && node.getAttribute('style') || '').toLowerCase().replace(/\s+/g, '');
      if (s.indexOf('background:') > -1 && s.indexOf('padding:') > -1) return node;
    }
    return null;
  }

  function run() {
    if (!document.body || document.body.classList.contains('sw')) return;
    document.querySelectorAll('h2').forEach(function (h2) {
      var t = normalizeHeadingText(h2.textContent);
      if (t !== "what you'll also need") return;
      var section = findSection(h2);
      if (!section) return;
      section.classList.add('sg-build-editorial');
      if (window.dispatchEvent) {
        window.dispatchEvent(new Event('resize'));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
}());


/* sg-pdp-section-normalizer-v8 */
(function () {
  'use strict';

  function cleanText(el) {
    return String(el && el.textContent || '')
      .replace(/[’‘]/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function inlineStyle(el) {
    return String(el && el.getAttribute && el.getAttribute('style') || '')
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function isSimGolferPdp() {
    if (!document.body || document.body.classList.contains('sw')) return false;
    return /^\/products\//.test(window.location.pathname || '') ||
      Array.prototype.some.call(document.body.classList, function (name) {
        return name === 'product' || name.indexOf('product-') === 0;
      });
  }

  function editorialLabels(section) {
    return Array.prototype.filter.call(section.querySelectorAll('span'), function (span) {
      var s = inlineStyle(span);
      return s.indexOf('text-transform:uppercase') > -1 && s.indexOf('letter-spacing') > -1;
    });
  }

  function removeBuildClasses(section) {
    section.classList.remove('sg-build-editorial');
    delete section.dataset.sgBuildEditorial;

    section.querySelectorAll(
      '.sg-build-list,.sg-build-row,.sg-build-name,.sg-build-desc,.sg-build-meta,.sg-build-icon,.sg-build-bullet-list,.sg-build-bullet-row,.sg-build-table'
    ).forEach(function (el) {
      el.classList.remove(
        'sg-build-list','sg-build-row','sg-build-name','sg-build-desc','sg-build-meta',
        'sg-build-icon','sg-build-bullet-list','sg-build-bullet-row','sg-build-table'
      );
      if (el.dataset) {
        delete el.dataset.sgBuildRowV6;
        delete el.dataset.sgBuildEditorial;
      }
    });
  }

  function resetSectionType(section) {
    section.classList.remove(
      'sg-section-included',
      'sg-section-build',
      'sg-section-compat',
      'sg-section-faq',
      'sg-section-specs',
      'sg-section-fit',
      'sg-section-room',
      'sg-section-features'
    );
  }

  function classify(section) {
    if (!section) return;

    var headings = Array.prototype.map.call(section.querySelectorAll('h2'), cleanText);
    var labels = editorialLabels(section);
    var labelText = labels.map(cleanText);

    var isIncluded =
      headings.indexOf("what's included") > -1 ||
      headings.indexOf("what's in the box") > -1 ||
      headings.indexOf('in the box') > -1 ||
      labelText.indexOf("what's included") > -1;

    var isFaq =
      headings.indexOf('frequently asked questions') > -1 ||
      section.querySelector('.sgp-fq,.trugolf-faq-q,details summary');

    var isSpecs =
      section.classList.contains('sg-techspecs') ||
      headings.indexOf('technical specifications') > -1 ||
      headings.indexOf('specifications') > -1 ||
      headings.some(function (heading) {
        return heading === 'technical specs' ||
          heading.indexOf('technical specs ') === 0 ||
          heading === 'tech specs' ||
          heading.indexOf('tech specs ') === 0 ||
          heading === 'technical details';
      });

    var isCompat =
      headings.indexOf('compatible devices & software') > -1 ||
      headings.indexOf('compatible software') > -1 ||
      headings.indexOf('compatible simulator software') > -1 ||
      headings.indexOf('compatible with') > -1 ||
      headings.indexOf('compatible software & launch monitors') > -1 ||
      headings.indexOf('compatible hardware') > -1 ||
      headings.indexOf('software & compatibility') > -1 ||
      headings.indexOf('works with your simulator setup') > -1 ||
      headings.indexOf('compatibility') > -1;

    var isFit =
      headings.some(function (heading) {
        return heading.indexOf('right for you') > -1 ||
          heading === 'best for' ||
          heading.indexOf('who is it for') > -1 ||
          heading.indexOf('who is this for') > -1;
      }) ||
      labelText.some(function (label) {
        return label.indexOf("buyer's guide") > -1 ||
          label.indexOf('choose with confidence') > -1;
      });

    var isRoom =
      headings.some(function (heading) {
        return heading.indexOf('room size guide') === 0 ||
          heading.indexOf('room size & mounting guide') === 0 ||
          heading === 'room requirements' ||
          heading.indexOf('does your room qualify') > -1 ||
          heading.indexOf('will it fit your room') > -1 ||
          heading.indexOf('will it fit your space') > -1 ||
          heading === 'plan your space' ||
          heading === "space you'll need";
      });

    var isFeatures =
      headings.indexOf('key features') > -1;

    var isBuild =
      headings.indexOf("what you'll also need") > -1 ||
      headings.indexOf('build your setup') > -1 ||
      headings.indexOf('popular add-ons') > -1 ||
      headings.indexOf('add the pieces that suit your room') > -1 ||
      headings.indexOf('choose a compatible mat') > -1 ||
      labelText.indexOf('build your setup') > -1 ||
      labelText.indexOf('complete your setup') > -1 ||
      labelText.indexOf('complete the setup') > -1;

    resetSectionType(section);

    // Included has priority because several legacy templates used generic card/grid markup
    // that previously fooled the build-section decorator.
    if (isIncluded) {
      removeBuildClasses(section);
      section.classList.add('sg-section-included');
    } else if (isBuild) {
      section.classList.add('sg-section-build');
    }

    if (isFaq) section.classList.add('sg-section-faq');
    if (isSpecs) section.classList.add('sg-section-specs');
    if (isCompat) section.classList.add('sg-section-compat');
    if (isFit) section.classList.add('sg-section-fit');
    if (isRoom) section.classList.add('sg-section-room');
    if (isFeatures) section.classList.add('sg-section-features');

    labels.slice(0,2).forEach(function (span) {
      span.classList.add('sg-section-eyebrow');
    });
  }

  function run(root) {
    if (!isSimGolferPdp()) return;
    (root || document).querySelectorAll('.sgpf').forEach(classify);
  }

  var timer = null;
  function queue() {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { run(document); }, 40);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); }, { once:true });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target || document);
  });

  window.addEventListener('load', function () { run(document); }, { once:true });

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      var changed = mutations.some(function (m) {
        return m.addedNodes && m.addedNodes.length;
      });
      if (changed) queue();
    }).observe(document.documentElement, {childList:true, subtree:true});
  }
}());


/* sg-pdp-final-authority-v10 */
(function () {
  'use strict';

  function norm(el) {
    return String(el && el.textContent || '')
      .replace(/[’‘]/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function styleText(el) {
    return String(el && el.getAttribute && el.getAttribute('style') || '')
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function isSimGolferPdp() {
    if (!document.body || document.body.classList.contains('sw')) return false;
    return /^\/products\//.test(window.location.pathname || '') ||
      Array.prototype.some.call(document.body.classList, function (c) {
        return c === 'product' || c.indexOf('product-') === 0;
      });
  }

  function sectionFor(h2) {
    if (!h2) return null;
    var known = h2.closest && h2.closest('.sgpf,.sg-build-editorial,.sg-compat-editorial,.sg-included-editorial');
    if (known) return known;

    var node = h2.parentElement;
    for (var i = 0; node && node !== document.body && i < 6; i++, node = node.parentElement) {
      var s = styleText(node);
      if ((s.indexOf('background:') > -1 || s.indexOf('background-color:') > -1) &&
          (s.indexOf('padding:') > -1 || s.indexOf('padding-top:') > -1)) {
        return node;
      }
      if (node.tagName === 'SECTION') return node;
    }
    return h2.parentElement && h2.parentElement.parentElement;
  }

  function removeBuild(section) {
    if (!section) return;
    section.classList.remove('sg-build-editorial','sg-section-build');
    delete section.dataset.sgBuildEditorial;
    section.querySelectorAll(
      '.sg-build-list,.sg-build-row,.sg-build-name,.sg-build-desc,.sg-build-meta,.sg-build-icon,.sg-build-bullet-list,.sg-build-bullet-row,.sg-build-table'
    ).forEach(function (el) {
      el.classList.remove(
        'sg-build-list','sg-build-row','sg-build-name','sg-build-desc','sg-build-meta',
        'sg-build-icon','sg-build-bullet-list','sg-build-bullet-row','sg-build-table'
      );
      if (el.dataset) {
        delete el.dataset.sgBuildRowV6;
        delete el.dataset.sgBuildEditorial;
      }
    });
  }

  function markIncluded(section) {
    if (!section) return;
    removeBuild(section);
    section.classList.add('sg-section-included','sg-included-editorial');
  }

  function markBuild(section) {
    if (!section || section.classList.contains('sg-section-included')) return;
    section.classList.add('sg-section-build','sg-build-editorial');
  }

  function markFaq(section) {
    if (section) section.classList.add('sg-section-faq');
  }

  function markSpecs(section) {
    if (section) section.classList.add('sg-section-specs');
  }

  function markCompat(section) {
    if (section) section.classList.add('sg-section-compat');
  }

  function markFit(section) {
    if (section) section.classList.add('sg-section-fit');
  }

  function markRoom(section) {
    if (section) section.classList.add('sg-section-room');
  }

  function markFeatures(section) {
    if (section) section.classList.add('sg-section-features');
  }

  function run(root) {
    if (!isSimGolferPdp()) return;
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('h2').forEach(function (h2) {
      var h = norm(h2);
      var section = sectionFor(h2);
      if (!section) return;

      if (
        h === "what's included" ||
        h === "what's in the box" ||
        h === 'in the box'
      ) {
        markIncluded(section);
        return;
      }

      if (
        h === "what you'll also need" ||
        h === 'build your setup' ||
        h === 'popular add-ons' ||
        h === 'add the pieces that suit your room' ||
        h === 'choose a compatible mat'
      ) {
        markBuild(section);
      }

      if (h === 'frequently asked questions' || h === 'questions') markFaq(section);

      if (
        h.indexOf('right for you') > -1 ||
        h === 'best for' ||
        h.indexOf('who is it for') > -1 ||
        h.indexOf('who is this for') > -1
      ) markFit(section);

      if (
        h.indexOf('room size guide') === 0 ||
        h.indexOf('room size & mounting guide') === 0 ||
        h === 'room requirements' ||
        h.indexOf('does your room qualify') > -1 ||
        h.indexOf('will it fit your room') > -1 ||
        h.indexOf('will it fit your space') > -1 ||
        h === 'plan your space' ||
        h === "space you'll need"
      ) markRoom(section);

      if (h === 'key features') markFeatures(section);

      if (h === 'technical specifications' || h === 'specifications') markSpecs(section);

      if (
        h === 'compatible devices & software' ||
        h === 'compatible software' ||
        h === 'compatible simulator software' ||
        h === 'compatible with' ||
        h === 'compatible software & launch monitors' ||
        h === 'compatible hardware' ||
        h === 'software & compatibility' ||
        h === 'works with your simulator setup' ||
        h === 'compatibility'
      ) {
        markCompat(section);
      }
    });

    /* Labels catch metafield-driven blocks whose H2 wording differs. */
    scope.querySelectorAll('.sgpf').forEach(function (section) {
      var labels = Array.prototype.map.call(section.querySelectorAll('span'), norm);
      if (labels.indexOf("what's included") > -1 || labels.indexOf("what's in the box") > -1) {
        markIncluded(section);
      }
    });
  }

  var timer = null;
  function queue(root) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { run(root || document); }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); }, { once:true });
  } else {
    run(document);
  }

  window.addEventListener('load', function () { run(document); }, { once:true });
  document.addEventListener('shopify:section:load', function (e) { run(e.target || document); });

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      var changed = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length; });
      if (changed) queue(document);
    }).observe(document.documentElement, { childList:true, subtree:true });
  }
}());

(function () {
  'use strict';
  function set(el, values) { if (el) Object.keys(values).forEach(function (key) { el.style.setProperty(key, values[key], 'important'); }); }
  function arrow(el) {
    if (!el || el.querySelector('.sg-design-arrow')) return;
    el.querySelectorAll('svg').forEach(function (svg) { svg.remove(); });
    el.innerHTML = el.innerHTML.replace(/→/g, '');
    el.insertAdjacentHTML('beforeend', '<svg class="sg-design-arrow" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" style="color:#d7bd78!important;stroke:#d7bd78!important"><path d="M4 12h15m-6-6 6 6-6 6" stroke="#d7bd78" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="stroke:#d7bd78!important"/></svg>');
  }
  function run() {
    if (!document.body || document.body.classList.contains('sw') || !/^\/products\//.test(location.pathname)) return;
    document.querySelectorAll('.sg-section-included,.sg-section-build').forEach(function (section) {
      if (section.matches('.sg-curved-box,.sg-curved-setup') || section.querySelector('.sg-curved-box,.sg-curved-setup')) return;
      section.classList.add('sg-design-panel');
      var host = section.closest('.shopify-section');
      if (host) {
        host.classList.add('sg-design-host');
        set(host, {padding:'0',margin:'0',width:'100%','max-width':'none'});
        var wrapper = host.querySelector('section[id]');
        if (wrapper && wrapper !== section) { set(wrapper, {padding:'0',margin:'0',width:'100%','max-width':'none'}); Array.prototype.forEach.call(wrapper.children, function (el) { if (el.contains(section)) set(el,{padding:'0',margin:'0',width:'100%','max-width':'none'}); }); }
      }
      set(section,{padding:'42px 24px',background:'#002e22',color:'#fff','max-width':'none',width:'100%'});
      if (section.firstElementChild && section.firstElementChild.tagName === 'DIV') set(section.firstElementChild,{'max-width':'980px',width:'100%',margin:'0 auto'});
      var heading=section.querySelector('h2');
      set(heading,{'font-size':innerWidth<=749?'32px':'34px','line-height':'1.12','letter-spacing':'-.025em',margin:'0 0 16px',color:'#fff'});
      section.querySelectorAll('.sg-editorial-rule,[style*="height:2px"],[style*="height: 2px"]').forEach(function(el){set(el,{width:'32px',height:'2px',background:'#c5a55a',margin:'0 0 26px'});});
      section.querySelectorAll('.sg-build-list').forEach(function(el){set(el,{display:'grid','grid-template-columns':innerWidth<=749?'1fr':'repeat(3,minmax(0,1fr))',gap:innerWidth<=749?'0':'0 32px','border-top':'0'});});
      section.querySelectorAll('.sg-build-row').forEach(function(row){
        set(row,{display:'flex','flex-direction':'column','align-items':'flex-start',gap:'0',padding:'22px 0',border:'0','border-top':'1px solid rgba(255,255,255,.2)',background:'transparent'});
        set(row.querySelector('.sg-build-name'),{'font-size':'18px','line-height':'1.4',margin:'0 0 8px',color:'#fff','grid-column':'auto','grid-row':'auto'});
        set(row.querySelector('.sg-build-desc'),{'font-size':'15px','line-height':'1.65',color:'#d5e0da','grid-column':'auto','grid-row':'auto'});
        var meta=row.querySelector('.sg-build-meta');
        set(meta,{display:'inline-flex','align-items':'center',gap:'8px',color:'#d7bd78','font-size':'14px','line-height':'1.5','text-align':'left','max-width':'100%','align-self':'flex-start','grid-column':'auto','grid-row':'auto',margin:'6px 0 0',padding:'10px 0','text-transform':'none','letter-spacing':'normal'});
        var anchor=row.matches('a')?row:row.querySelector('a');
        if (anchor && meta) {
          if (!meta.querySelector('.sg-design-arrow') && /^view\s*(?:product)?\s*→?\s*$/i.test(meta.textContent.trim())) {
            var labels={'/collections/projectors':'Browse projectors','/collections/launch-monitors':'Browse launch monitors','/collections/hitting-mats':'Browse hitting mats','/collections/enclosures-screens':'Browse enclosures & screens','/collections/accessories':'Browse accessories'};
            meta.textContent=labels[anchor.getAttribute('href')]||'View product';
          }
          arrow(meta);
        }
        if (!anchor && meta && /sourced separately/i.test(meta.textContent)) { row.classList.add('sg-design-requirement'); set(row,{'grid-column':'1 / -1',padding:'16px 18px',background:'rgba(255,255,255,.055)',border:'0','border-left':'2px solid #c5a55a',margin:'0 0 26px'}); set(meta,{'font-size':'11px',padding:'6px 0 0',margin:'0',color:'#d7bd78'}); }
      });
    });
    document.querySelectorAll('.sg-section-fit').forEach(function(section){
      if (section.classList.contains('sg-curved-fit-cards')) return;
      section.querySelectorAll('div,article').forEach(function(card){
        var s=(card.getAttribute('style')||'').replace(/\s/g,'').toLowerCase();
        if (!(/background:#(?:f0fdf4|fff5f5|fef2f2)/.test(s)||(/box-shadow:/.test(s)&&card.children.length>=2)||card.matches('.bmt-fit-card,.eyexr-fit-card'))) return;
        card.classList.add('sg-design-fit-card');
        set(card,{background:'#fff',border:'0','border-radius':'10px',padding:'28px 32px','box-shadow':'0 1px 4px rgba(0,0,0,.05),0 8px 28px rgba(0,0,0,.07)','min-width':'0'});
        var title=card.querySelector('h3,h4,strong')||card.firstElementChild;
        set(title,{color:'#002e22','font-size':'18px','line-height':'1.4',margin:'0 0 10px'});
        if(title)title.querySelectorAll('svg').forEach(function(svg){svg.style.setProperty('display','none','important');});
        Array.prototype.forEach.call(card.children,function(el){if(el!==title&&!el.matches('span'))set(el,{color:'#4b5563','font-size':'14px','line-height':'1.7'});});
      });
    });
  }
  var timer;
  function queue(){clearTimeout(timer);timer=setTimeout(run,180);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',queue);else queue();
  window.addEventListener('load',queue);window.addEventListener('resize',queue,{passive:true});document.addEventListener('shopify:section:load',queue);
  new MutationObserver(function(ms){if(ms.some(function(m){return m.addedNodes.length;}))queue();}).observe(document.documentElement,{childList:true,subtree:true});
}());
